var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"tabs__header"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.title,class:{
        tab__selected: index === _vm.selectedIndex,
        'full-width': _vm.fullWidth,
      },staticStyle:{"font-size":"14px"},on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }